/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ModuleAccessTypes.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { customAppColors } from "../../assets/app-theme/appColors";

function ModuleAccessTypes({
  selectedProjectDetails,
  selectedPaBtn,
  setSelectedPaBtn,
  moduleTypes,
  hideProject = false,
}) {
  return (
    <Paper
      elevation={3}
      sx={{
        width: 220,
        height: "50%",
      }}
    >
      {[
        ...(hideProject
          ? []
          : [{ value: moduleTypes?.PROJECT, label: "Project" }]),
        { value: moduleTypes?.VARIANT, label: "Variant" },
        {
          value: moduleTypes?.VEHICLE_SYSTEM,
          label: "Vehicle System",
        },
        {
          value: moduleTypes?.VEHICLE_COMPONENT,
          label: "Vehicle Component",
        },
        { value: moduleTypes?.EE, label: "EE Component" },
        { value: moduleTypes?.SWM, label: "Software Module" },
      ].map((el) => {
        const isActive = selectedPaBtn === el.value;

        return (
          <Box
            key={el.value || el.label}
            onClick={() => setSelectedPaBtn(el.value)}
            sx={{
              display: "flex",
              alignItems: "center",
              px: 2,
              py: 1.2,
              cursor: "pointer",
              bgcolor: isActive ? "white" : "transparent",
              position: "relative",
              "&:hover": {
                bgcolor: "#d6d6d6",
              },
            }}
          >
            {isActive && (
              <Box
                sx={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: 4,
                  bgcolor: customAppColors.green,
                }}
              />
            )}

            <Typography
              sx={{
                flexGrow: 1,
                fontSize: 14,
                color: "#000",
              }}
              textAlign={"start"}
            >
              {el.label}
            </Typography>
          </Box>
        );
      })}
    </Paper>
  );
}

ModuleAccessTypes.propTypes = {
  selectedProjectDetails: PropTypes.object,
  selectedPaBtn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelectedPaBtn: PropTypes.func,
  moduleTypes: PropTypes.shape({
    PROJECT: PropTypes.string,
    VARIANT: PropTypes.string,
    VEHICLE_SYSTEM: PropTypes.string,
    VEHICLE_COMPONENT: PropTypes.string,
    EE: PropTypes.string,
    SWM: PropTypes.string,
  }),
  hideProject: PropTypes.bool,
};

export default ModuleAccessTypes;
